import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, catchError, map } from 'rxjs/operators';
import { SiteService } from 'src/app/api/services';
import { loadSiteByCity, loadSiteByCity_Failure, loadSiteByCity_Success } from './site.actions';

@Injectable()
export class SiteEffects {

  constructor(private actions$: Actions, private siteService: SiteService) { }

  public loadSiteByCity$ = createEffect(() => {

    return this.actions$.pipe(
      ofType(loadSiteByCity),
      switchMap(({ cityId }) =>
        this.siteService.siteGetForKiosk({ CityId: cityId, IsActive: true }).pipe(
          map((site) => loadSiteByCity_Success({ data: site })),
          catchError((err) => of(loadSiteByCity_Failure({ error: err })))
        )
      )
    );
  });
}
